import React, { createContext, useEffect, useMemo } from "react";

type CustomStorageProviderProps = {
  children: React.ReactNode;
};

export type CustomStorageContextData = {
  getItem: (key: string) => any;
  setItem: (key: string, value: any) => void;
  removeItem: (key: string) => void;
  clear: () => void;
};

export const CustomStorageContext = createContext<CustomStorageContextData>(
  {} as CustomStorageContextData
);

export function CustomStorageProvider({
  children,
}: CustomStorageProviderProps) {
  const getItem = (key: string) => {
    const storedValue = localStorage.getItem(key);

    try {
      return storedValue ? JSON.parse(storedValue) : null;
    } catch {
      return storedValue;
    }
  };

  const setItem = (key: string, value: any) => {
    localStorage.setItem(key, value);
  };

  const removeItem = (key: string) => {
    localStorage.removeItem(key);
  };

  const clear = () => {
    localStorage.clear();
  };

  const CustomStorageContextData = useMemo(() => {
    return {
      getItem,
      setItem,
      removeItem,
      clear,
    };
  }, []);

  return (
    <CustomStorageContext.Provider value={CustomStorageContextData}>
      {children}
    </CustomStorageContext.Provider>
  );
}
